import { apiConfig } from './api';
import { gameConfig } from './game';
import { wsConfig } from './ws';

export { gameConfig };

export const appConfig = {
  apiConfig,
  wsConfig,
};
